import { styled } from '@linaria/react';
import { memo } from 'react';
import { AppStateType, useAppState, useAppStateSelector } from '../../Hooks/useAppState';
import Login from './Login';
import SignUp from './SignUp';
import "./index.linaria.module.css!=!./index?./index.linaria.module.css?css=H4sIAAAAAAAAA3WQ2w7CIAyG730PE73AbHcGnobTGBlQAp2bGt/dbLqFebjs939t0564H279pborm6PjV0oGLTqLRMDIPlnjdAF9nkEpzkKrrWmR1lW1Z2UnrdnSQ2u2kEIgyiYt0UKgElzvw+p/J3/89zTurAnEovaZSh1QJ1bc9YrXYNmxoT8mCC47k6APikhwkOiFpwMhBcbEQ3b95B9Z5ErZYAhCpOc4rrUARPAb5HSDG5DmD07ksXsCnHsdRaIBAAA="
export const AuthRoot = /*#__PURE__*/styled('div')({
  name: "AuthRoot",
  class: "amwzuv0",
  propsAsIs: false
});
type AuthenticationProps = {
  subject?: string;
  redirect?: string;
  signup?: boolean;
};
const Authentication = memo((props: AuthenticationProps) => {
  const isAuthenticated = useAppStateSelector(AppStateType.APP, 'authenticated');
  const authState = useAppState(AppStateType.AUTHENTICATION);
  const {
    success,
    verified
  } = authState;
  const {
    subject,
    signup,
    redirect
  } = props;
  if (signup && (!isAuthenticated || success || verified)) {
    return <SignUp />;
  }
  return <Login subject={subject} redirect={redirect} />;
});
export default Authentication;